export const SUPPLEMENT_TYPES = {
  IMAGE: 'image',
  PASSAGE: 'passage',
  AUDIO: 'audio',
  SORTABLE_TABLE: 'sortable-table',
  FREE_FORM: 'free-form'
};

export const SUPPLEMENT_TYPES_LIST = [
  SUPPLEMENT_TYPES.IMAGE,
  SUPPLEMENT_TYPES.PASSAGE,
  SUPPLEMENT_TYPES.AUDIO,
  SUPPLEMENT_TYPES.SORTABLE_TABLE,
  SUPPLEMENT_TYPES.FREE_FORM
];

export const supplementModes = {
  EDIT: 'edit',
  EDIT_ACTIVE: 'editActive',
  SEARCH: 'search'
} as const;
